import React, { FC } from "react"
import { Helmet } from "react-helmet"
import { Header, SideMenu } from "shared/components"
import SEO from "../seo"
import {
  container,
  document,
  main,
  sideBar,
  content,
} from "../../styles/privacy-policy.styles"
import "../../styles/index.css"
/** @jsx jsx */
import { jsx } from "@emotion/react"
import { IMAGES } from "../../utils/images"
import { ROUTES } from "../../content/common-content"
import  "shared/styles/index.css"


/**
 * Terms of use main container
 *
 */

const Layout: FC<{
  title: string
  path: string
}> = ({ children, title, path }) => (
  <div css={container}>
    <SEO title={`${title} | Quizzop`} />
    <Helmet>
      <meta charSet="utf-8" />
      <meta http-equiv="X-UA-Compatible" content="IE=edge" />
      <title>{title} | Quizzop</title>
      <meta name="description" content="Quizzop Terms and Conditions." />
      <meta name="viewport" content="width=device-width, initial-scale=0.2" />
      <link rel="icon" href={IMAGES.IC_INFO} />
      <link
        href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700,900&display=swap"
        rel="stylesheet"
      />
    </Helmet>
    <div css={document}>
      <Header
        logo={IMAGES.QUIZZOP_LOGO}
        list={[
          {
            heading: "Quizzop",
            link: "https://www.quizzop.com",
          },
          {
            heading: "Business Website",
            link: "https://business.gamezop.com",
          },
        ]}
      />
      <div css={main}>
        <div css={sideBar}>
          <SideMenu path={path} sideBarList={ROUTES} />
        </div>
        <div css={content}>{children}</div>
      </div>
    </div>
  </div>
)

export default Layout
